import cx from 'clsx';
import * as React from 'react';

import useJackpotIncrement from '@/hooks/useJackpotIncrement';
import { JackpotType } from '@/types/gameTypes';
import { formatNumberToCurrency } from '@/utils/currency';

import styles from './JackpotLayer.module.scss';

type JackpotLayerProps = { componentType: 'search' | 'gameTile' } & JackpotType;

const GT_JACKPOT_VALUE = 'gt-jackpot_value';

const JackpotLayer = ({
  value,
  currencyCode,
  increaseVelocity,
  timestamp,
  updateInterval,
  componentType,
}: JackpotLayerProps) => {
  const jackpotValue = useJackpotIncrement(
    value,
    timestamp,
    increaseVelocity,
    updateInterval
  );
  return (
    <>
      <span
        className={cx(
          styles.text,
          componentType === 'gameTile' && styles.jackpotGameTileFont
        )}
        data-testid={GT_JACKPOT_VALUE}
      >
        {formatNumberToCurrency(jackpotValue, currencyCode, true)}
      </span>
    </>
  );
};

export default JackpotLayer;
